import { render, staticRenderFns } from "./ExamManagement.vue?vue&type=template&id=637500be"
import script from "./ExamManagement.vue?vue&type=script&lang=js"
export * from "./ExamManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports